const tabs = {
    get_started: 'Erste Schritte',
    dashboard: 'Dashboard',
    applications: 'Anwendungen',
    api_resources: 'API Ressourcen',
    sign_in_experience: 'Anmeldeoberfläche',
    connectors: 'Connectoren',
    users: 'Benutzerverwaltung',
    audit_logs: 'Audit Logs',
    docs: 'Dokumentation',
    contact_us: 'Kontakt',
    settings: 'Einstellungen',
};
export default tabs;
